import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { TMatchDetail } from "../../../Types";
import getKhattabatStore from "..";
import getKhattabatSharedMessagingStore from "../messaging-stores/conversation-messaging-store";
import getKhattabat101MMessagingStore from "./101m-messaging-store";

class Khattabat101MMatchStore {
  matchID = observable.box<number>(0);
  matchStatus = observable.box<string>("");
  matchUserName = observable.box<string>("");
  matchUUID = observable.box<string>("");
  matchResidence = observable.box<string>("");
  matchNationality = observable.box<string>("");
  matchAge = observable.box<number>(0);
  matchHeight = observable.box<number>(0);
  matchWeight = observable.box<number>(0);
  matchLastLogin = observable.box<string>("");
  marriageType = observable.box<string>("");
  matchConvesationIsDisabled = observable.box<boolean>(false);
  matchConversationIsHighlighted = observable.box<boolean>(false);
  matchHasDeletedTheConversation = observable.box<boolean>(false);
  hasOneOTwoWithClient = observable.box<boolean>(false);
  matchIsSlackAlertsEnabled = observable.box<boolean>(false);
  isSilentBanned = observable.box<number>(0);

  setMatchData = (matchDetail: TMatchDetail) => {
    runInAction(() => {
      this.matchStatus.set(matchDetail.matchStatus);
      this.matchUserName.set(matchDetail.matchUserName);
      this.matchUUID.set(matchDetail.matchUUID);
      this.matchResidence.set(matchDetail.matchResidence);
      this.matchNationality.set(matchDetail.matchNationality);
      this.matchAge.set(matchDetail.matchAge);
      this.matchHeight.set(matchDetail.matchHeight);
      this.matchWeight.set(matchDetail.matchWeight);
      this.matchLastLogin.set(matchDetail.matchLastLogin);
      this.marriageType.set(matchDetail.marriageType);

      getKhattabatSharedMessagingStore(
        this.conversationID.get()
      ).setUnreadMessagesCounter(matchDetail.matchUnreadMessages);
      this.matchConvesationIsDisabled.set(
        matchDetail.matchConvesationIsDisabled
      );
      this.matchConversationIsHighlighted.set(
        matchDetail.matchConversationIsHighlighted
      );
      this.matchHasDeletedTheConversation.set(
        matchDetail.matchHasDeletedTheConversation
      );
      this.hasOneOTwoWithClient.set(matchDetail.hasOneOTwoWithClient);
      this.matchIsSlackAlertsEnabled.set(matchDetail.matchIsSlackAlertsEnabled);
      this.isSilentBanned.set(matchDetail.isSilentBanned);

      getKhattabat101MMessagingStore(this.matchID.get()).updateConversation({
        messages: matchDetail.messages,
        comments: matchDetail.oneOOneMComments
      });
    });
  };

  conversationID = computed(() =>
    getKhattabatStore().getOneOOneConversationsId({
      userUUID: this.matchUUID.get()
    })
  );
}

const getKhattabat101MatchStore = memoize((matchID: number) => {
  const store = new Khattabat101MMatchStore();
  store.matchID.set(matchID);
  return store;
});
export default getKhattabat101MatchStore;
